module.exports = __webpack_public_path__ + "assets/d44a2cb4d86f28ac9ec2f9bf74d63097.svg";